<template>
    <div class="wrapperd">
        <!-- 右侧table及各个功能 -->
        <div class="tableinfo">
            <div class="search">
                <span class="font">全部设备：共{{ totalCount }}台</span>
                <div class="searchinput">
                    <Input :style="{width:'180px;'}" search enter-button placeholder="请输入查询内容"/>
                </div>
                <div>
                    <Button type="primary" size="large" @click="exportData">
                        <Icon type="ios-download-outline"></Icon>
                        导出表格
                    </Button>
                    <Button type="primary" size="large" @click="onLargeScreen">
                        <Icon type="ios-desktop-outline"></Icon>
                        查看大屏
                    </Button>
                    <Button type="primary" size="large" @click="onReport()">
                        <Icon type="ios-desktop-outline"></Icon>
                        查看加工报表
                    </Button>
                </div>
            </div>
            <div class="content">
                <Table v-loading="loading"
                       element-loading-text="加载中..."
                       :columns="title"
                       :data="content"
                       size="small"
                       ref="table"
                       @on-selection-change="selectTip"
                       :max-height="540"
                ></Table>
                <Button type="primary" icon="ios-search" class="searchbtn" @click="tostatusInfo">按时间序列查询</Button>
                <Button type="primary" icon="ios-search" class="searchbtn" @click="toScheduleStatistics">按班组统计</Button>
                <Page style="position:absolute;bottom:0em; margin-top: 10%" :total="totalCount" :current="pageNum"
                      :page-size="10" show-elevator show-sizer show-total placement="top"
                      @on-change="handlePage"></Page>
            </div>
            <!--      <Modal v-model="statusinfoshow" class="statusstyle" fullscreen footer-hide>-->
            <!--        <statusinfonew :statusinfonew="{selections,statusinfoshow}" @modelshow="modelshow"></statusinfonew>-->
            <!--      </Modal>-->
        </div>
      <!-- 报警详情对话框 -->
      <Modal v-model="alarmDetailVisible" title="报警详情" width="800">
        <div v-if="currentAlarmData">
          <h3>设备信息</h3>
          <Divider />
          <Row :gutter="16">
            <Col span="12">
              <p><strong>机床名称:</strong> {{ currentAlarmData.alias }}</p>
              <p><strong>机床型号:</strong> {{ currentAlarmData.model }}</p>
              <p><strong>序列号:</strong> {{ currentAlarmData.serial }}</p>
            </Col>
            <Col span="12">
              <p><strong>系统型号:</strong> {{ currentAlarmData.CNC }}</p>
              <p><strong>当前状态:</strong>
                <span :style="{color: getStatusColor(currentAlarmData.status)}">
                            {{ currentAlarmData.status }}
                        </span>
              </p>
              <p><strong>总报警次数:</strong> {{ currentAlarmData.alarmCount }}</p>
            </Col>
          </Row>

          <h3 style="margin-top: 20px">报警记录列表</h3>
          <Divider />

          <!-- 报警列表 -->
          <Table
              :columns="alarmColumns"
              :data="alarmHistory"
              size="small"
              style="margin-top: 15px"
              height="300"
          >
            <template slot-scope="{ row }" slot="action">
              <Button type="primary" size="small" @click="handleAlarmAction(row, 'acknowledge')">确认</Button>
              <Button type="error" size="small" style="margin-left: 8px" @click="handleAlarmAction(row, 'clear')">清除</Button>
            </template>
          </Table>

          <!-- 分页控件 -->
<!--          <div style="margin-top: 16px; text-align: center">-->
<!--            <Page-->
<!--                :total="alarmTotalCount"-->
<!--                :current="alarmPageNum"-->
<!--                :page-size="alarmPageSize"-->
<!--                show-elevator-->
<!--                show-total-->
<!--                @on-change="handleAlarmPageChange"-->
<!--            />-->
<!--          </div>-->
        </div>
        <div slot="footer">
<!--          <Button @click="alarmDetailVisible = false">取消</Button>-->
          <Button type="primary" @click="handleAlarmOK">确定</Button>
        </div>
      </Modal>
    </div>
</template>
<script>
import report from "./report";
import {post} from "@/apis/restUtils";
export default {
    data() {
        return {
            date: "",
            nodeKey: "",
            pageNum: 1,
            totalCount: 11,
            statusinfoshow: false, //详情弹窗是否展示
            scheduleStatisticsShow: false,
            dateChoose: "", //table选择开始结束时间
            currentPage: 1, //分页当前页数,
          alarmDetailVisible: false, // 报警详情对话框显示状态
          currentAlarmData: null, // 当前选中报警的数据
          alarmHistory: [], // 报警历史数据
          alarmColumns: [
            {
              title: '报警时间',
              key: 'time',
              width: 150
            },
            {
              title: '报警代码',
              key: 'code',
              width: 100
            },
            {
              title: '报警描述',
              key: 'description'
            },
            {
              title: '严重程度',
              key: 'severity',
              render: (h, params) => {
                const severity = params.row.severity;
                let color = 'default';
                if (severity === '高') color = 'error';
                if (severity === '中') color = 'warning';
                if (severity === '低') color = 'success';

                return h('Tag', {
                  props: {
                    color: color
                  }
                }, severity);
              }
            }
          ],
            title: [
                {
                    title: "机床名称",   //"客户名称",
                    key: "alias",
                    sortable: true,
                    width: 150
                },
                {
                    title: "机床型号",
                    key: "model",
                    sortable: true
                },
                {
                    title: "机床序列号",
                    key: "serial",
                    sortable: true,
                    width: 150
                },
                {
                    title: "系统型号",
                    key: "CNC",
                    sortable: true
                },
                // {
                //     title: "出厂日期",
                //     key: "productionDate",
                //     sortable: true
                // },
                {
                    title: "当前状态",
                    key: "status",
                    sortable: true,
                    render: (h, params) => {
                        return h("div", [
                            h("icon", {
                                props: {
                                    type: "primary",
                                    size: "small"
                                },
                                style: {
                                    width: "8px",
                                    height: "8px",
                                    backgroundColor:
                                        params.row.status == "加工"
                                            ? "#19be6b"
                                            : params.row.status == "故障"
                                            ? "#ed4014" : params.row.status == "停机"
                                                ? "#fffc02" : params.row.status == "未连接" ?
                                                    "#808080" : "#e9e9e9",
                                    borderRadius: "50%",
                                    marginRight: "8px"
                                }
                            }),
                            h("strong", params.row.status)
                        ]);
                    }
                },

                {
                    title: "加工时间",
                    key: "workTime",
                    sortable: true,
                    width: 130
                },
                {
                    title: "加工件数",
                    key: "workPieces",
                    sortable: true
                },
                // {    //暂时隐藏
                //     title: "利用率",
                //     key: "utilization",
                //     sortable: true,
                //
                //     render: (h, params) => {
                //         return h('span', (() => {
                //             let utilization = params.row.utilization;
                //             return utilization + '%';
                //         })());
                //     }
                // },
              {
                title: "报警次数",
                key: "alarmCount",
                sortable: true,
                render: (h, params) => {
                  const count = params.row.alarmCount;
                  if (count > 0) {
                    return h("a", {
                      style: {
                        // color: '#ed4014',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        fontWeight: 'bold'
                      },
                      on: {
                        click: () => {
                          this.showAlarmDetail(params.row);
                        }
                      }
                    }, count.toString());
                  } else {
                    return h("span", count.toString());
                  }
                }
              },
                {
                    title: "报警标记",
                    key: "warning",
                    sortable: true
                },
                {
                    title: "操作",
                    type: "selection",
                    width: 60,
                    align: "center"
                }
            ],
            content: [
            ],
            selections: [], //操作中选中的所选项数组
            loading: true,
            paramDate: {'selectDate': ''},

        };
    },
    mounted: function () {
        // this.date = new Date();
    },
    methods: {
        // table导出表格
        // exportData() {  //老的实现方式
        //     this.$refs.table.exportCsv({
        //         filename: "equipsList"
        //     });
        // },
        exportData() {  //新的实现方式
            let that = this;
            this.$Modal.confirm({
                title: '选择日期',
                render: (h) => {
                    return h(report, {
                        ref: 'report',
                        props: {
                            date: this.paramDate,
                        },
                    });
                },
                onOk() {
                    that.$emit('onDownloadReportData', {'nodeKey': that.nodeKey, 'beginDate': that.paramDate.selectDate[0], 'endDate': that.paramDate.selectDate[1]});
                }
            });

        },

        modelshow(val) {
            this.statusinfoshow = val;
        },
        //   分页
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        },
        // 选择要查看详细信息的列
        selectTip(selection) {
            this.selections = selection;
            this.$emit('onselection', {'selections': this.selections, 'statusinfoshow': this.statusinfoshow});
            // 已选择的当前信息（数组）
            console.log(selection);
        },
        // 列表跳转详细信息页面
        tostatusInfo() {
            this.statusinfoshow = true;
            this.$emit('onshowstatusinfo', {'selections': this.selections, 'statusinfoshow': this.statusinfoshow});
            this.statusinfoshow = false;
        },
        toScheduleStatistics() {
            this.scheduleStatisticsShow = true;
            this.$emit('onscheduleStatistics', {
                'selections': this.selections,
                'scheduleStatisticsShow': this.scheduleStatisticsShow
            });
            this.scheduleStatisticsShow = false
        },
        onLargeScreen() {
            this.$router.push({path: '/bigScreen?nodeKey=' + this.nodeKey});
        },
        onReport() {
            let that = this;
            this.$Modal.confirm({
                title: '选择日期',
                render: (h) => {
                    return h(report, {
                        ref: 'report',
                        props: {
                            date: this.paramDate,
                        },
                    });
                },
                onOk() {
                  that.$emit('onDownloadProgramWorkReport', {'nodeKey': that.nodeKey, 'beginDate': that.paramDate.selectDate[0], 'endDate': that.paramDate.selectDate[1], "selections": that.selections});
                }
            });
        },
      showAlarmDetail(rowData) {
        this.currentAlarmData = rowData;
        this.alarmDetailVisible = true;
        this.alarmHistory = [];
        // 获取报警历史数据
        this.fetchAlarmHistory(rowData.id);
      },
      // 获取报警历史数据
      fetchAlarmHistory(machineId) { //, pageNum = 1
        // 模拟API调用获取报警历史
        this.loading = true;

        // 这里应该是实际的API调用
        post("/organization/customer/web/getOneDayStatusForChengdu",
            {"id": machineId, "beginDate": "", "endDate": ""},
            response => {
              this.alarmHistory = response.data.entity;
              this.loading = false;
            }
        );
        // this.$api.getAlarmHistory({ machineId, pageNum, pageSize: this.alarmPageSize })
        //   .then(response => {
        //       this.alarmHistory = response.data.list;
        //       this.alarmTotalCount = response.data.total;
        //       this.alarmPageNum = pageNum;
        //   })
        //   .catch(error => {
        //       console.error("获取报警历史失败:", error);
        //       this.$Message.error("获取报警历史失败");
        //   })
        //   .finally(() => {
        //       this.loading = false;
        //   });
        //
        // // 模拟数据
        // setTimeout(() => {
        //   this.alarmHistory = [
        //     {
        //       id: 1,
        //       time: '2023-06-15 10:23:45',
        //       code: 'ALM102',
        //       description: '主轴过载保护，请检查切削参数',
        //       severity: '高',
        //       status: '活跃'
        //     },
        //     {
        //       id: 2,
        //       time: '2023-06-14 15:42:18',
        //       code: 'ALM056',
        //       description: '润滑油压力低，请检查油路',
        //       severity: '中',
        //       status: '已确认'
        //     },
        //     {
        //       id: 3,
        //       time: '2023-06-13 09:12:37',
        //       code: 'ALM201',
        //       description: '冷却系统异常，温度过高',
        //       severity: '中',
        //       status: '已清除'
        //     },
        //     {
        //       id: 4,
        //       time: '2023-06-10 16:35:22',
        //       code: 'ALM077',
        //       description: '刀具寿命警告，建议更换刀具',
        //       severity: '低',
        //       status: '已清除'
        //     }
        //   ];
        //   this.alarmTotalCount = 24; // 模拟总记录数
        //   this.alarmPageNum = pageNum;
        //   this.loading = false;
        // }, 500);
      },

      // 处理报警操作（确认/清除）
      handleAlarmAction(alarm, action) {
        let actionText = action === 'acknowledge' ? '确认' : '清除';

        this.$Modal.confirm({
          title: '操作确认',
          content: `您确定要${actionText}此报警吗？`,
          onOk: () => {
            // 这里应该是实际的API调用
            // this.$api.handleAlarm({ alarmId: alarm.id, action })
            //   .then(response => {
            //       this.$Message.success(`报警已${actionText}`);
            //       this.fetchAlarmHistory(this.currentAlarmData.serial, this.alarmPageNum);
            //   })
            //   .catch(error => {
            //       console.error(`${actionText}报警失败:`, error);
            //       this.$Message.error(`${actionText}报警失败`);
            //   });

            // 模拟操作成功
            this.$Message.success(`报警已${actionText}`);

            // 更新本地数据
            const index = this.alarmHistory.findIndex(a => a.id === alarm.id);
            if (index !== -1) {
              if (action === 'acknowledge') {
                this.alarmHistory[index].status = '已确认';
              } else if (action === 'clear') {
                this.alarmHistory[index].status = '已清除';
              }
            }
          }
        });
      },

      // 报警列表分页变化
      handleAlarmPageChange(pageNum) {
        this.fetchAlarmHistory(this.currentAlarmData.serial, pageNum);
      },

      // 点击确定按钮
      handleAlarmOK() {
        // 这里可以添加一些处理逻辑，比如保存更改等
        console.log("处理报警详情确定操作");

        // 关闭对话框
        this.alarmDetailVisible = false;
      },

      // 获取状态对应的颜色
      getStatusColor(status) {
        const colorMap = {
          "加工": "#19be6b",
          "故障": "#ed4014",
          "停机": "#ff9900",
          "未连接": "#808080"
        };
        return colorMap[status] || "#2d8cf0";
      }
    }
};
</script>
<style scoped>
.wrapperd {
    width: 100%;
    height: 100%;
    margin: 0% auto;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    /*overflow: auto;*/
}

.wrapper > div {
    height: 90%;
    background-color: white;
    border-radius: 3px;
}

.treelist {
    width: 16%;
    padding-top: 2em;
}

.statusstyle {
    /* min-height: 860px; */
}

.tableinfo {
    width: 100%;
    padding: 2em -1em;
}

.font {
    font-size: 16px;
    font-weight: bold;
    margin-right: 1em;
}

.search {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 2em;
}

.searchinput {
    width: 240px;
    display: flex;
    flex-direction: row;
}

.searchbtn {
    float: right;
    margin: 2em 1em;
}

/* 分页 */
.pagenum {
    text-align: center;
    position: absolute;
    bottom: 5em;
}
</style>